import React, { Component } from 'react';
import LoaderWrapper from '../../../../Components-2025/QuestionBank/LoaderWrapper';
import VideoPlayListView from '../../../../Components-2025/Videos/VideoPlayList';
import ComponentHeader from '../../../../common/ComponentHeader';
import { messages } from '../../../../common/messages';
import config from '../../../config/AppRoutes';
import apiServiceProvider from './ApiService';
import { chapterIdKey, mockIdKey, videoTableKey, videoTitleKey, youtubeIdKey } from './ApiAttributesKays';
import ModalComponent from '../../../Common/Modal';
import alertMessage from '../../../config/alertMessage';
import { showInformation } from '../../../../common/toast';
import VideoValidateReportsIcons from '../../../../Components-2025/Videos/VideoValidateReportsIcons';
import FlashCard from '../../../../components/FlashCard';
import ReportCard from '../../../../Components-2025/QuestionBank/ReportCard';

export default class VideoPlayList extends Component {
  static contextTypes = { router: React.PropTypes.object };
  constructor(props) {
    super(props);
    this.state = {
      videoData: [],
      currentIndex: 0,
      isLoading: true,
      isFlashCardHidden: true,
      showReportSection: false,
      openPremiumPopup: false,
      isUserSubscribedPart1: false,
      isUserSubscribedPart2: false,
      isUserSubscribedForPart1AndPart2: false,
      mockId: null,
    };
    this.childRef = null;
    this.setChildRef = (element) => {
      this.childRef = element;
    };
  }
  async componentDidMount() {
    this.setState({ isLoading: true });

    const { level, chapterId, id, mockId } = this.props.params;

    await this.getChapterWiseVideos({
      level,
      chapterId,
      id,
      mockId,
    });
  }
  getChapterWiseVideos = async (payload) => {
    const result = await apiServiceProvider['fetchVideos'](payload);
    if (result.success) {
      const videosData = result.data[0][videoTableKey]
        ? result.data[0][videoTableKey]
        : result.data;
      const { id } = payload;
      const currentIndex = videosData.findIndex((item) => item.id === parseInt(id, 10));
      const isCurrentVideoFree = videosData.length
        ? videosData[currentIndex > -1 ? currentIndex : 0].free
        : false;
      const isUserSubscribedPartWisePackage =
        result.selectedExamSubscriptionDetails[`subscriptionDetailsForFrm${payload.level}`] &&
        result.selectedExamSubscriptionDetails[`subscriptionDetailsForFrm${payload.level}`]
          .videoStatus;
      const isUserSubscribedForPart1AndPart2 =
        result.selectedExamSubscriptionDetails['subscriptionDetailsForFrm1And2'] &&
        result.selectedExamSubscriptionDetails['subscriptionDetailsForFrm1And2'].videoStatus;


      if (
        isUserSubscribedForPart1AndPart2 ||
        isUserSubscribedPartWisePackage ||
        isCurrentVideoFree
      ) {
        this.setState({
          isLoading: false,
          currentIndex: currentIndex > -1 ? currentIndex : 0,
          videoData: videosData.length ? videosData : result.data[videoTableKey],
          [`isUserSubscribedPart${payload.level}`]: isUserSubscribedPartWisePackage,
          isUserSubscribedForPart1AndPart2,
          mockId: payload.mockId,
        });
      } else {
        const { router } = this.context;
        router.push({ pathname: config.FRM_VIDEOS });
        showInformation(messages.PLEASE_SUBSCRIBE_TO_ACCESS_THIS_VIDEO);
      }
    } else {
      this.setState({ isLoading: false });
    }
  };

  navigateToVideoByID = async (index) => {
    const { level } = this.props.params;
    const { state } = this;
    const { isUserSubscribedForPart1AndPart2, videoData } = state;
    const video = videoData[index];
    if (
      isUserSubscribedForPart1AndPart2 ||
      state[`isUserSubscribedPart${level}`] ||
      video.free
    ) {
      // Get the mockId for the selected video
      const mockId = video[mockIdKey] ? video[mockIdKey] : null;

      this.setState({ currentIndex: index, mockId });

      const { router } = this.context;

      const videoPathName = video.mock_id
        ? config.FRM_V2_VIDEOS_MOCK_PLAYLIST.replace(':mockId', video.mock_id)
        : config.FRM_V2_VIDEOS_PLAYLIST.replace(':chapterId', video.chapter_id);

      router.push({
        pathname: videoPathName
          .replace(':level', level)
          .replace(':id', video.id),
      });
      const payLoad = {
        video_id: videoData[index].id,
        level,
      };
      await apiServiceProvider['saveLastViewedVideo'](payLoad);
    } else {
      this.setState({ openPremiumPopup: true });
    }
  };
  goPremium = () => {
    const { router } = this.context;
    router.push({ pathname: '/Subscribe' });
  };
  toggleAlert = () => {
    this.setState({ openPremiumPopup: !this.state.openPremiumPopup });
  };

  onSaveItemChange = (status) => {
    this.setState({ isFlashCardHidden: status });
  };
  toggleReportSection = () =>
    this.setState((prevState) => ({ showReportSection: !prevState.showReportSection }));
  hideReportSection = () => {
    this.setState({ showReportSection: false });
  };
  render() {
    const { router } = this.context;
    const { level } = this.props.params;
    const { state } = this;
    const {
      videoData,
      isLoading,
      currentIndex,
      isUserSubscribedForPart1AndPart2,
      openPremiumPopup,
      isFlashCardHidden,
      showReportSection,
      mockId,
    } = state;

    return (
      <div className='animated fadeIn'>
        <LoaderWrapper isLoading={isLoading}>
          <div>
            <ComponentHeader>
              <button
                className='btn btn-primary pointer_class'
                onClick={() => router.push({ pathname: config.FRM_VIDEOS })}
              >
                {messages.BACK_TO_VIDEOS}
              </button>
            </ComponentHeader>
            <VideoPlayListView
              videoTitle={videoData[currentIndex] ? videoData[currentIndex][videoTitleKey] : ''}
              currentIndex={currentIndex}
              videosData={videoData}
              youtubeID={videoData[currentIndex] ? videoData[currentIndex][youtubeIdKey] : ''}
              navigateToVideoByID={this.navigateToVideoByID}
              toggleAlert={this.toggleAlert}
              isUserSubscribed={
                isUserSubscribedForPart1AndPart2 || state[`isUserSubscribedPart${level}`]
              }
            />
            <br /> <br />
            <VideoValidateReportsIcons
              isMoveToNotesIcon={!mockId}
              isMoveToQuestionIcon={!mockId}
              toggleAlert={this.toggleAlert}
              savePayLoad={{
                videoId: videoData[currentIndex] ? videoData[currentIndex].id : '',
                level,
              }}
              favItemId={videoData[currentIndex] ? videoData[currentIndex].id : ''}
              notesRedirectRoute={config.FRM_V2_NOTES_READING_LIST.replace(':level', level).replace(
                ':chapterId',
                videoData[currentIndex] ? videoData[currentIndex][chapterIdKey] : '',
              )}
              questionRedirectRoute={config.FRM_V2_QUESTION_BANK_READING_LIST.replace(
                ':level',
                level,
              ).replace(
                ':chapterId',
                videoData[currentIndex] ? videoData[currentIndex][chapterIdKey] : '',
              )}
              setChildRef={this.childRef}
              currentVideo={videoData[currentIndex] && videoData[currentIndex]}
              apiServiceProvider={apiServiceProvider}
              onSaveItemChange={this.onSaveItemChange}
              toggleReportSection={this.toggleReportSection}
              isUserSubscribed={
                isUserSubscribedForPart1AndPart2 || state[`isUserSubscribedPart${level}`]
              }
            />
            <FlashCard
              item={{ id: videoData[currentIndex] ? videoData[currentIndex].id : '' }}
              type='video'
              isFlashCardHidden={isFlashCardHidden}
              ref={this.setChildRef}
              exam='frm'
              level={level}
            />
            {showReportSection && (
              <ReportCard
                section='video'
                hideReportSection={this.hideReportSection}
                apiServiceProvider={apiServiceProvider}
                itemId={videoData[currentIndex] ? videoData[currentIndex].id : ''}
                keyId='video_id'
                level={level}
              />
            )}
          </div>
        </LoaderWrapper>
        <ModalComponent
          goPremium={this.goPremium}
          toggleAlert={this.toggleAlert}
          alert_status={openPremiumPopup}
          MessageContent={alertMessage.messageContent_frm}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/FRM-V2/Videos/PlayList/VideoPlayList.jsx